<template>
  <div class="yoyo-container mx-auto min-h-screen bg-gray-50 pb-[env(safe-area-inset-bottom)]">
    <navBar />
    <!-- 用户信息卡片 -->
    <div class="m-4 bg-white rounded-2xl p-4 pt-4 pb-3 shadow-sm user-info-card" :style="cardStyle">
      <h2 class="text-xl font-semibold text-gray-800" @click="handleLogin">{{ userInfo.nickname || $t("common.pleaseLogin") }}</h2>
      <div class="flex items-center mt-1" v-if="isLoggedIn">
        <img v-if="userInfo.countryIcon" :src="imageBaseUrl + userInfo.countryIcon" class="w-5 h-auto mr-2 border border-gray-200" />
        <span class="text-gray-600 text-sm">{{ isZh ? userInfo.countryName : userInfo.countryNameEn }}</span>
      </div>

      <!-- 探索者等级 -->
      <div class="flex items-center justify-between mt-2" v-if="isLoggedIn">
        <div class="flex-1 flex items-center mr-3">
          <img :src="imageBaseUrl + (userInfo.level && userInfo.level.icon)" class="w-12 h-12 mr-1" />
          <span class="text-blue-600 font-medium">
            {{ isZh ? userInfo.level && userInfo.level.name : userInfo.level && userInfo.level.nameEn }}
          </span>
        </div>
        <div class="text-sm text-gray-500 mt-1 flex items-center">
          {{ $t("yoyoCoins.currentBalance") }}
          <span class="text-xl font-semibold text-gray-700 ml-2">{{ userInfo.point }}</span>
        </div>
      </div>
    </div>

    <!-- 个人资料 -->
    <div class="mx-4 mt-4 bg-white rounded-xl overflow-hidden shadow-sm px-4"  v-if="isLoggedIn">
      <van-cell :title="$t('mine.personalInfo')" is-link @click="goTo('/user-info')" class="">
        <template #title>
          <div class="flex items-center">
            <img src="@/assets/images/mine/1.png" class="w-5 h-5 mr-1" />
            <span class="text-gray-600">{{ $t("mine.personalInfo") }}</span>
          </div>
        </template>
      </van-cell>
      <!-- 微章进度 -->
      <van-cell :title="$t('mine.myBadges')" :border="false" is-link @click="goTo('/my-badges')" class="">
        <template #title>
          <div class="flex items-center">
            <img src="@/assets/images/mine/95.png" class="w-4 h-4 mr-2" />
            <span class="text-gray-600">{{ $t("mine.myBadges") }}</span>
          </div>
        </template>
      </van-cell>
      <div class="flex items-center justify-between mt-0">
        <div class="flex items-center space-x-2">
          <div
            class="w-12 h-12 rounded-full flex items-center justify-center border border-gray-200"
            :class="userInfo.level && userInfo.level.level === 1 ? 'bg-orange-100' : 'bg-white'">
            <img src="@/assets/images/huizhang/1.png" class="w-10 h-10" />
          </div>
          <div
            class="w-12 h-12 rounded-full flex items-center justify-center border border-gray-200"
            :class="userInfo.level && userInfo.level.level === 2 ? 'bg-orange-100' : 'bg-white'">
            <img src="@/assets/images/huizhang/2.png" class="w-10 h-10" />
          </div>
          <div
            class="w-12 h-12 rounded-full flex items-center justify-center border border-gray-200"
            :class="userInfo.level && userInfo.level.level === 3 ? 'bg-orange-100' : 'bg-white'">
            <img src="@/assets/images/huizhang/3.png" class="w-10 h-10" />
          </div>
          <div
            class="w-12 h-12 rounded-full flex items-center justify-center border border-gray-200"
            :class="userInfo.level && userInfo.level.level === 4 ? 'bg-orange-100' : 'bg-white'">
            <img src="@/assets/images/huizhang/4.png" class="w-10 h-10" />
          </div>
          <div
            class="w-12 h-12 rounded-full flex items-center justify-center border border-gray-200"
            :class="userInfo.level && userInfo.level.level === 5 ? 'bg-orange-100' : 'bg-white'">
            <img src="@/assets/images/huizhang/5.png" class="w-10 h-10" />
          </div>
        </div>
      </div>
      <div class="mt-4 text-[13px] text-gray-600">
        {{ $t("mine.currentPoints") }}
        <span class="font-semibold text-[#ff7a00]">{{ userInfo.totalPoint }}</span>
        {{ $t("mine.points") }}，{{ $t("mine.currentLevel") }}：{{
          isZh ? userInfo.level && userInfo.level.name : userInfo.level && userInfo.level.nameEn
        }}
      </div>

      <div class="h-[1px] border-b border-gray-200 my-3 mb-2"></div>

      <!-- 我的yoyo币 -->
      <van-cell :title="$t('mine.myYoyoCoins')" is-link :border="false" @click="goTo('/yoyo-coins')" class="">
        <template #title>
          <div class="flex items-center">
            <img src="@/assets/images/mine/2.png" class="w-4 h-4 mr-2" />
            <span class="text-gray-600">{{ $t("mine.myYoyoCoins") }}</span>
          </div>
        </template>
      </van-cell>
      <div class="space-y-1 text-[13px]">
        <div class="flex">
          <span class="text-gray-600">{{ $t("mine.accumulated") }}：</span>
          <span class="font-medium">{{ userInfo.totalPoint }}</span>
        </div>
        <div class="flex">
          <span class="text-gray-600">{{ $t("mine.used") }}：</span>
          <span class="font-medium">
            {{ userInfo.usePoint }}
            <span class="text-gray-400 ml-1" v-if="isLoggedIn">({{ $t("mine.discountRM") }}{{ userInfo.usePointPrice }})</span>
          </span>
        </div>
        <div class="">
          <span class="text-gray-600">{{ $t("yoyoCoins.currentBalance") }}：</span>
          <span class="font-medium">
            {{ userInfo.point }}
            <span class="text-gray-400 ml-1" v-if="isLoggedIn">({{ isZh ? userInfo.expireTip : userInfo.expireTipEn }})</span>
          </span>
        </div>
      </div>

      <div class="h-[1px] border-b border-gray-200 my-2 mb-2"></div>

      <!-- 我的优惠券 -->
      <van-cell :title="$t('mine.myCoupons')" :border="false" is-link @click="goTo('/my-coupons')" class="">
        <template #title>
          <div class="flex items-center">
            <img src="@/assets/images/mine/6.png" class="w-4 h-4 mr-2" />
            <span class="text-gray-600">{{ $t("mine.myCoupons") }}</span>
          </div>
        </template>
      </van-cell>
      <div class="space-y-1 text-[13px] pb-2">
        <div class="flex">
          <span class="text-gray-600">{{ $t("mine.unused") }}：</span>
          <span class="font-medium" v-if="userInfo.coupon">
            {{ isZh ? userInfo.coupon && userInfo.coupon.name : userInfo.coupon && userInfo.coupon.nameEn }}
            <span class="text-gray-400">
              ({{ $t("mine.validUntil2025") }} {{ formatTime(userInfo.coupon && userInfo.coupon.validEndTime) }})
            </span>
          </span>
        </div>
        <div class="flex">
          <span class="text-gray-600">{{ $t("mine.used") }}：</span>
          <span class="font-medium">{{ userInfo.couponUseCount }}{{ isLoggedIn ? $t("mine.pieces") : "" }}</span>
        </div>
      </div>
    </div>

    <div class="mx-4 mt-4 bg-white rounded-xl overflow-hidden shadow-sm px-4"  v-if="isLoggedIn">
      <!-- 订单 -->
      <van-cell :title="$t('mine.myOrders')" is-link @click="goTo('/my-orders')" class="">
        <template #title>
          <div class="flex items-center">
            <img src="@/assets/images/mine/97.png" class="w-4 h-4 mr-2" />
            <span class="text-gray-600">{{ $t("mine.myOrders") }}</span>
          </div>
        </template>
      </van-cell>
      <!-- 评价 -->
      <van-cell :title="$t('mine.reviews')" is-link @click="goTo('/my-reviews')" class="">
        <template #title>
          <div class="flex items-center">
            <img src="@/assets/images/mine/98.png" class="w-4 h-4 mr-2" />
            <span class="text-gray-600">{{ $t("mine.reviews") }}</span>
          </div>
        </template>
      </van-cell>
      <!-- 待办 -->
      <van-cell :title="$t('mine.toDo')" is-link @click="goTo('/my-to-do')" class="">
        <template #title>
          <div class="flex items-center">
            <img src="@/assets/images/mine/99.png" class="w-4 h-4 mr-2" />
            <span class="text-gray-600">{{ $t("mine.toDo") }}</span>
          </div>
        </template>
      </van-cell>
      <!-- 收藏 -->
      <van-cell :title="$t('mine.favorites')" is-link @click="goTo('/my-favorites')" class="">
        <template #title>
          <div class="flex items-center">
            <img src="@/assets/images/mine/100.png" class="w-4 h-4 mr-2" />
            <span class="text-gray-600">{{ $t("mine.favorites") }}</span>
          </div>
        </template>
      </van-cell>
      <!-- 绑定 -->
      <van-cell :title="$t('mine.binds')" :border="false" is-link @click="goTo('/my-binds')" class="" >
        <template #title>
          <div class="flex items-center">
            <img src="@/assets/images/mine/bind_1.png" class="w-4 h-4 mr-2" />
            <span class="text-gray-600">{{ $t("mine.binds") }}</span>
          </div>
        </template>
      </van-cell>
      <!-- <div class="space-y-1 text-[13px] pb-2">
        <div class="text-gray-600">iccid: {{ userInfo.lastBind && userInfo.lastBind.iccid }}</div>
        <div v-if="userInfo.lastBind">
          <div class="text-gray-600">{{ isZh ? userInfo.lastBind.planName : userInfo.lastBind.planNameEn }}</div>
          <div class="text-gray-600">
            {{ isZh ? userInfo.lastBind.packageValue.name : userInfo.lastBind.packageValue.nameEn }} {{ userInfo.lastBind.day }}
          </div>
          <div class="text-gray-600" v-if="userInfo.lastBind.status == 0">
            {{ computedStatus(userInfo.lastBind.status) }} &nbsp;({{ userInfo.lastBind.validTime }})
          </div>
          <div class="text-gray-600" v-else-if="userInfo.lastBind.status == 3 || userInfo.lastBind.status == 9 || userInfo.lastBind.status == 99">
            {{ computedStatus(userInfo.lastBind.status) }}
          </div>
          <div class="text-gray-600" v-else>
            {{ computedStatus(userInfo.lastBind.status) }} &nbsp; {{ userInfo.lastBind.startDate }} {{ userInfo.lastBind.startDate && '-' }} {{ userInfo.lastBind.endDate }}
          </div>
        </div>
      </div> -->
    </div>

    <div class="mx-4 mt-4 bg-white rounded-xl overflow-hidden shadow-sm px-4">
      <van-cell :title="$t('mine.language')" is-link @click="dialogVisible = true" class="">
        <template #title>
          <div class="flex items-center">
            <img src="@/assets/images/mine/5.png" class="w-4 h-4 mr-1" />
            <span class="text-gray-600">{{ $t("mine.language") }}</span>
          </div>
        </template>
      </van-cell>
      <!-- 客服 -->
      <van-cell :title="$t('mine.customerService')" is-link :border="false" @click="handleCustomService" class="">
        <template #title>
          <div class="flex items-center">
            <img src="@/assets/images/mine/101.png" class="w-4 h-4 mr-1" />
            <span class="text-gray-600">{{ $t("mine.customerService") }}</span>
          </div>
        </template>
      </van-cell>
    </div>

    <div class="my-6 pb-10 flex justify-center" v-if="isLoggedIn">
      <van-button class="w-60 rounded-xl" plain color="#ff7a00" @click="handleLogout">{{ $t("login.loggout") }}</van-button>
    </div>

    <!-- <van-tabbar route :class="['z-999 transition-transform duration-300 flex md:hidden', { 'translate-y-full': !showTabbar }]">
      <van-tabbar-item :to="item.to" v-for="item in tabbarItems" :key="item.name">
        <template #icon>
          <img :src="item.icon" class="w-14 h-14" />
        </template>
      </van-tabbar-item>
    </van-tabbar> -->

    <TipDialog :visible.sync="dialogVisible" type="language" @button-click="handleButtonClick" @close="handleClose" />

    <CommonDialog
      :visible.sync="logoutDialogVisible"
      :buttons="[
        { text: this.$t('common.cancel'), type: 'secondary', action: 'cancel' },
        { text: this.$t('common.confirm'), type: 'primary', action: 'confirm' },
      ]"
      @button-click="handleLogoutDialog"
      @close="handleLogoutDialogClose">
      <div class="text-center">
        <div class="mb-4">
          {{ $t("login.logoutConfirm") }}
        </div>
      </div>
    </CommonDialog>
  </div>
</template>

<script>
import dayjs from "dayjs"
import { Locale, Cell, Image as VanImage, Tabbar, TabbarItem } from "vant" // 引入英文语言包
import enUS from "vant/es/locale/lang/en-US"
import zhCN from "vant/es/locale/lang/zh-CN"
import { mapActions, mapGetters, mapMutations } from "vuex"
import TipDialog from "@/components/home/TipDialog.vue"
import { updateLanguage } from "@/apis/userInfo"

export default {
  name: "Mine",

  data() {
    return {
      // tabbarItems: [
      //   { name: "cart", icon: require("@/assets/images/card.png"), to: { name: "cart", query: { showTabbar: true } }, w: 8 },
      //   { name: "home", icon: require("@/assets/images/home.png"), to: { name: "home" }, w: 8 },
      //   { name: "yoyoCoinIntroduce", icon: require("@/assets/images/yoyo.png"), to: { name: "yoyoCoinIntroduce" }, w: 10 },
      //   { name: "mine", icon: require("@/assets/images/mine.png"), to: { name: "mine" }, w: 10 },
      // ],
      baseInfo: {},
      dialogVisible: false,
      // 用户信息卡片动画状态
      userCardAnimated: false,
      // 卡片的实际高度
      cardActualHeight: "auto",
      // 滚动相关状态
      showTabbar: true,
      lastScrollTop: 0,
      scrollThreshold: 1, // 滚动阈值
      logoutDialogVisible: false,
    }
  },
  components: {
    [Cell.name]: Cell,
    [VanImage.name]: VanImage,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    TipDialog,
  },
  computed: {
    ...mapGetters({
      userInfo: "auth/userInfo",
      isLoggedIn: "auth/isLoggedIn",
      isZh: "lang/isZh",
    }),
    tabbarItems() {
      return this.isZh
        ? [
            { name: "home", icon: require("@/assets/images/tabbar/home.png"), to: { name: "home" }, w: 8 },
            { name: "yoyoCoinIntroduce", icon: require("@/assets/images/tabbar/yoyo.png"), to: { name: "yoyoCoinIntroduce" }, w: 10 },
            { name: "cart", icon: require("@/assets/images/tabbar/cart.png"), to: { name: "cart", query: { showTabbar: true } }, w: 8 },
            { name: "mine", icon: require("@/assets/images/tabbar/my-active.png"), to: { name: "mine" }, w: 10 },
          ]
        : [
            { name: "home", icon: require("@/assets/images/tabbar/home-en.png"), to: { name: "home" }, w: 8 },
            { name: "yoyoCoinIntroduce", icon: require("@/assets/images/tabbar/yoyo-en.png"), to: { name: "yoyoCoinIntroduce" }, w: 10 },
            { name: "cart", icon: require("@/assets/images/tabbar/cart-en.png"), to: { name: "cart", query: { showTabbar: true } }, w: 8 },
            { name: "mine", icon: require("@/assets/images/tabbar/my-en-active.png"), to: { name: "mine" }, w: 10 },
          ]
    },
    imageBaseUrl() {
      return process.env.VUE_APP_IMAGE_URL
    },
    // 用户信息卡片样式
    cardStyle() {
      // 未登录时高度使用 auto，不受之前测量高度影响
      if (!this.isLoggedIn) {
        return {
          height: "auto",
          opacity: 1,
          overflow: "hidden",
          transition: "all 0.6s ease-out",
        }
      }

      const fullHeight = this.cardActualHeight === "auto" ? "auto" : this.cardActualHeight + "px"
      const reducedHeight = this.cardActualHeight === "auto" ? "auto" : this.cardActualHeight * 0.8 + "px"

      return {
        height: this.userCardAnimated ? fullHeight : reducedHeight,
        opacity: this.userCardAnimated ? 1 : 0.7,
        overflow: "hidden",
        transition: "all 0.6s ease-out",
      }
    },
  },
  methods: {
    ...mapActions({
      fetchUserInfo: "auth/fetchUserInfo",
    }),
    ...mapMutations({
      setLoginDialogVisible: "auth/SET_LOGIN_DIALOG_VISIBLE",
      setIsZh: "lang/SET_IS_ZH",
      CLEAR_USER_INFO: "auth/CLEAR_USER_INFO",
    }),
    formatTime(time) {
      return dayjs(time).format("YYYY-MM-DD")
    },
    // async fetchBaseInfo() {
    //   try {
    //     const response = await getBaseInfo()
    //     // console.log('response :>> ', response);
    //     this.baseInfo = response.data
    //   } catch (error) {
    //     console.error("获取用户信息失败:", error)
    //   }
    // },
    goTo(url) {
      if (!this.isLoggedIn) {
        this.handleLogin()
        return
      }
      this.$router.push(url)
    },
    handleLanguage() {
      console.log("跳转到语言设置")
    },
    handleCustomerService() {
      console.log("跳转到客服")
    },
    handleLogin() {
      if (!this.isLoggedIn) {
        this.setLoginDialogVisible(true)
      }
    },
    handleButtonClick({ action }) {
      console.log("111 :>> ", 111)
      // 切换语言，持久化到 localStorage
      try {
        const newLang = action === "english" ? "en" : "zh-CN"
        this.$i18n.locale = newLang
        Locale.use(newLang === "en" ? "en-US" : "zh-CN", newLang === "en" ? enUS : zhCN)

        localStorage.setItem("lang", newLang)
        this.setIsZh(newLang === "zh-CN")
        if(this.isLoggedIn) {
          updateLanguage({ lang: newLang === "zh-CN" ? "zh" : "en" }).then(() => {
            console.log("语言更新成功")
          }).catch((error) => {
            console.error("语言更新失败:", error)
        })
        }
        
        this.handleClose()
        // 触发界面重新渲染，以确保文本切换生效
        this.$forceUpdate()
      } catch (error) {
        console.error("切换语言失败:", error)
      }
    },
    handleClose() {
      console.log("222 :>> ", 222)
      this.dialogVisible = false
      console.log("this.dialogVisible :>> ", this.dialogVisible)
    },
    // 处理滚动事件 - 结合两者优点的混合逻辑
    handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      const windowHeight = window.innerHeight
      const documentHeight = document.documentElement.scrollHeight

      // 2. 立即更新 Tabbar 显示逻辑（实时响应，无防抖）
      this.updateTabbarVisibility(scrollTop, windowHeight, documentHeight)
    },

    // HomeHeader 滚动进度更新（来自 HomeNew.vue）
    updateHeaderScrollProgress(scrollTop) {
      // 简单的线性计算：0-80px 范围内从 0 到 1
      this.scrollProgress = Math.min(scrollTop / this.maxScrollForHeaderAnimation, 1)
    },

    // Tabbar 显示逻辑（来自 Home.vue 的简单逻辑）
    updateTabbarVisibility(scrollTop, windowHeight, documentHeight) {
      // 顶部保护：在接近页面顶部（含 iOS 回弹的轻微负/正偏移）时，始终显示 tabbar
      const topBuffer = 2
      if (scrollTop <= topBuffer) {
        this.showTabbar = true
        this.lastScrollTop = 0
        return
      }
      // 判断是否滚动到页面底部（距离底部50px内）
      const isNearBottom = scrollTop + windowHeight >= documentHeight - 1

      // 如果在页面底部，显示tabbar
      if (isNearBottom) {
        this.showTabbar = true
        this.lastScrollTop = scrollTop
        return
      }

      // 判断滚动方向
      const scrollDirection = scrollTop > this.lastScrollTop ? "down" : "up"

      // 只有滚动距离超过阈值才触发显示/隐藏
      if (Math.abs(scrollTop - this.lastScrollTop) > this.scrollThreshold) {
        if (scrollDirection === "down") {
          // 向下滚动，隐藏tabbar
          this.showTabbar = false
        } else {
          // 向上滚动，显示tabbar
          this.showTabbar = true
        }
        this.lastScrollTop = scrollTop
      }
    },
    handleLogout() {
      // this.CLEAR_USER_INFO()
      if (!this.isLoggedIn) {
        return
      }
      this.logoutDialogVisible = true
    },
    handleLogoutDialog(btn) {
      const { action } = btn
      console.log("action :>> ", action)
      if (action === "confirm") {
        this.CLEAR_USER_INFO()
        // 重置卡片高度和动画状态，退出登录后恢复为默认高度
        this.cardActualHeight = "auto"
        this.userCardAnimated = false
        this.handleLogoutDialogClose()
        this.userCardAnimation()
      } else {
        this.handleLogoutDialogClose()
      }
    },
    handleLogoutDialogClose() {
      this.logoutDialogVisible = false
    },
    userCardAnimation() {
      this.$nextTick(() => {
        // 先获取卡片的实际高度
        const cardElement = this.$el.querySelector(".user-info-card")
        if (cardElement) {
          this.cardActualHeight = cardElement.offsetHeight
          // console.log("卡片实际高度:", this.cardActualHeight)

          // 然后开始动画
          setTimeout(() => {
            // console.log("触发用户信息卡片动画")
            this.userCardAnimated = true
            // console.log("userCardAnimated状态:", this.userCardAnimated)
          }, 100) // 100ms延迟确保页面完全加载
        }
      })
    },
    computedStatus(status) {
      // 0 未激活 1 已兑换 3 已激活 9 已结束 99 已失效
      let txt = ""
      switch (status) {
        case 0:
          txt = this.$t("binds.notActivated")
          break
        case 1:
          txt = this.$t("binds.exchanged")
          break
        case 3:
          txt = this.$t("binds.activated")
          break
        case 9:
          txt = this.$t("binds.finished")
          break
        case 99:
          txt = this.$t("binds.expired")
          break
        default:
          txt = status
          break
      }
      return txt
    },
    handleCustomService() {
      this.openInNewTab("https://wa.me/60143869383")
    },
    openInNewTab(url) {
      // 创建一个虚拟的 a 标签
      const link = document.createElement("a")
      link.href = url
      link.target = "_blank"
      link.rel = "noopener noreferrer"

      // 添加到 DOM 中（隐藏）
      link.style.display = "none"
      document.body.appendChild(link)

      // 触发点击事件
      link.click()

      // 移除元素
      document.body.removeChild(link)
    },
  },
  created() {
    // 添加滚动事件监听
    // window.addEventListener("scroll", this.handleScroll, { passive: true })
    this.fetchUserInfo()
      .then((data) => {
        // console.log("data :>> ", data)
        // this.baseInfo = data || {}
      })
      .catch((error) => {
        console.error("获取用户信息失败:", error)
      })
  },
  mounted() {
    // 页面挂载后延迟触发用户信息卡片动画，确保DOM完全渲染
    // console.log("Mine页面挂载，准备启动动画")
    this.userCardAnimation()
  },
}
</script>

<style scoped>
/deep/.van-cell {
  padding-left: 0;
  padding-right: 0;
}
/deep/.van-tabbar-item__icon img {
  height: auto;
}

/* 用户信息卡片基础样式 */
.user-info-card {
  /* 确保动画平滑 */
  will-change: transform, opacity;
}
</style>
